module.exports = __webpack_public_path__ + "static/media/019-Kissen_ID_23.ef678fa0.mp3";